<script setup>
const props = defineProps({
  dates: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <h2
    id="naechste-kursdaten"
    class="scale-3 scale-3--bold-uppercase spacer-40-30"
  >
    Nächste Kursdaten
  </h2>
  <ul class="date-list">
    <li
      v-for="(item, index) in props.dates"
      :key="index"
      class="d-flex flex-column flex-640-row"
    >
      <span class="scale-1 scale-1--bold">{{ item.date }}</span>
      <div
        v-if="item.soldOut"
        class="date-list__badge"
      >
        <div class="equal-small-2 sold-out">
          Ausgebucht
        </div>
      </div>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.date-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    padding: 30px 0;
    border-top: 1px solid $color-dark-01;

    &:last-child {
      border-bottom: 1px solid $color-dark-01;
    }
  }

  &__badge {
    margin-left: 20px;

    @include media-breakpoint-down(640) {
      margin-left: 0;
      margin-top: 15px;
    }
  }
}

.sold-out {
  background-color: $color-danger-02;
  display: inline-flex;
  align-items: center;
  height: 25px;
  padding: 0 8px;
  border-radius: 8px;
  line-height: 25px;
}
</style>
